export enum DonationFormLayouts {
  IFrame = 'iframe',
  Platform = 'platform',
}
